import sanitize from './htmlSanitizer';

export const removeShortcodes = (html: string): string => html.replace(/\[(.*?)\]/g, '');

export const parseWordpressContent = (html: string): string => removeShortcodes(sanitize(html));
